import { Groups } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, FormControl, FormGroup, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { current } from '@reduxjs/toolkit';
import { useEffect, useState } from 'react';
import { deepEqual, isObject } from '../helpers/objects';
import { capitalized } from '../helpers/strings';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const DEBOUNCE_WAIT = 250;

function getCurrentValue(field, data) {
    if(!data || !field) return "";
    var value = field.default ? field.default : "";
    if(field.name) {
        if (field.name in data) {
            value = data[field.name];
        }
    }
    if (isObject(value)) {
        return JSON.stringify(value);
    }
    return value;
}

const ModelEditField = ({field, data, onChange}) => {
    let datatype = typeof(field.default);
    var control = null;
    //const [currentValue, setCurrentValue] = useState(getCurrentValue(field, data));
    /*
    // debounce feature by useEffect and setTimeout
    useEffect(() => {
        if (currentValue && field) {
            const timer = setTimeout(() => {
                if(!onChange) return;
                if (datatype === "number") {
                    onChange(field.name, parseFloat(currentValue));
                } else {
                    onChange(field.name, currentValue);
                }
            }, DEBOUNCE_WAIT);
            return () => clearTimeout(timer);
        }
    }, [datatype, onChange, currentValue, field]);*/
    //const [currentValue, setCurrentValue] = useState(getCurrentValue(field, data))
    var currentValue = getCurrentValue(field, data);
    function setCurrentValue(value) {
        currentValue = value;
    }

    if(!field || !data) {
        return null;
    }
    if(!field.name) {
        return null;
    }

    const changeField = (event) => {
        setCurrentValue(event.target.value);
        if(!onChange) return;
        if (datatype === "number") {
            onChange(field.name, parseFloat(event.target.value));
        } else {
            onChange(field.name, event.target.value);
        }
    };

    var label = field.label ? field.label : capitalized(field.name);
    var fieldWidth = 240;

    if(field.uitype) {
        if(field.uitype === "choicebox") {
            control = <FormControl key={`$(field.name)_ctrl`} sx={{width: `${fieldWidth}px`}}>
            <InputLabel id={field.name + "_label"} variant="filled">{label}</InputLabel>
            <Select
            variant="filled"
              id="metadata-select"
              label={label}
              labelId={field.name + "_label"}
              value={currentValue ? currentValue : field.options[0]}
              onChange={changeField}
            >
              {field.options.map((option) => {
                return <MenuItem key={option} value={option}>{option}</MenuItem>
              })}
              </Select>
              </FormControl>
        }
    }

    if(!control) {
        switch (datatype) {
            case "number":
                control = <TextField key={field.name} sx={{width: `${fieldWidth}px`}} label={label} value={currentValue} onChange={changeField} variant="filled" />;
                break;
            case "string":
            case "object":
                control = <TextField key={field.name} sx={{width: `${fieldWidth}px`}} label={label} variant="filled" value={currentValue} onChange={changeField} />
                break;
            default:
                control = <div></div>
                break;
        }
    }
    return <Grid item key={field.name + "_stack"}>
        {control ? [control] : []}
    </Grid>
}

const ModelEditor = ({data, modelFunc, onChange}) => {
    const [modelData, setModelData] = useState(data);
    var fields = modelFunc();
    var field_groups = [];
    var last_group = "NONE";
    var current_group = null;
    if(!data) {
        return <></>
    }
    if(data && modelData) {
        if (!deepEqual(data, modelData)) {
            setModelData(data);
        }
    } else {
        if((data && !modelData) || (modelData && !data))
            setModelData(data);
    }
    var idx = 0;
    fields.forEach(field => {
        if(field.noui ? !field.noui : true) {
            let group = (field.group ? field.group : "");
            if(!current_group || (group !== last_group)) {
                if(current_group && (current_group.contents.length > 0))
                    field_groups.push(current_group);

                last_group = group;
                // start a new group
                current_group = {
                    "label": group,
                    "contents": [],
                    "index": idx,
                    "unnamed": group === ""
                };
                idx += 1;
            }
            // add the field
            current_group.contents.push(field);
        }
    });
    if (current_group && (current_group.contents.length > 0))
        field_groups.push(current_group);

    return <> 
        {
            field_groups.map(group => {
                return (
                    group.unnamed ? (
                        <Grid container spacing={2} key={`${group.label}_${group.index}`}>
                        {
                            group.contents.map(field => ModelEditField({field: field, data: modelData, onChange: onChange}))
                        }</Grid>) : (
                    <Accordion key={`${group.label}_${group.index}`} variant="outlined" sx={{borderRadius: 1}}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography>{capitalized(group.label)}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container spacing={2} key={`${group.label}_${group.index}`}>
                            {
                                group.contents.map(field => ModelEditField({field: field, data: modelData, onChange: onChange}))
                            }
                        </Grid>
                        </AccordionDetails>
                    </Accordion>));
            })
        }
    </>;
}
  
export default ModelEditor;
